module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-tired.816a59c4.png";